import React from "react";
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import { useTranslation } from "../../hooks/useTranslation";
import { MEDIA_URL } from '../../config/constants';

const Benefits = () => {
  const { t } = useTranslation('home');

  const icons = [WbSunnyIcon, SupportAgentIcon, DirectionsCarIcon];
  const benefitItems = t('benefits.items', { returnObjects: true });

  return (
    <div className="benefits-section">
      <div className="benefits-content-container">
        <div className="benefits-text-section">
          <h2 className="benefits-title">
            {t('benefits.title')} <br />
            {t('benefits.titleBrand')}
          </h2>
          <div className="benefits-features-container">
            {benefitItems.map((benefit, index) => {
              const IconComponent = icons[index];
              return (
                <div key={index} className="benefit-item">
                  <div className="benefit-icon">
                    <IconComponent sx={{ fontSize: 48, color: '#009b31' }} />
                  </div>
                  <div className="benefit-text-container">
                    <div className="benefit-title">{benefit.title}</div>
                    <div className="benefit-description">
                      {benefit.description}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="benefits-image-container">
          <img
            src={`${MEDIA_URL}/images/why-travel-with-sun-catchers-home.webp`}
            className="benefits-image"
            alt="Sun Catcher campervan interior with solar-powered amenities and comfortable living space"
            loading="lazy"
            width="600"
            height="450"
          />
        </div>
      </div>
    </div>
  );
};

export default Benefits;
